exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-container{background:rgba(0,0,0,.075)}.footer-container p{font-size:.7rem}@media screen and (max-width:576px){.footer-container{background:rgba(173,181,189,.85)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4aa27138","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FooterText.vue
// module id = 169
// module chunks = 0